import {Icon} from '@ezcater/tapas';
import {faChevronRight} from '@fortawesome/pro-solid-svg-icons';
import {StaticImageData} from 'next/image';
import Link from 'next/link';

import useTracking from '@/hooks/useTracking';

export type CaseStudyCase = {
  title: string;
  description: string;
  imageAvif: StaticImageData;
  imagePng: StaticImageData;
  imageWebp: StaticImageData;
  imageAlt: string;
  link: string;
};

type CaseStudiesCardProps = {
  case: CaseStudyCase;
};

const CaseStudiesCard: React.FC<CaseStudiesCardProps> = ({case: caseStudy}) => {
  const {trackClick} = useTracking();
  const {title, description, imageAlt, imageAvif, imageWebp, imagePng, link} = caseStudy;

  const trackCardClick = () => {
    trackClick(`case-studies-${title.toLowerCase().replace(/\s+/g, '-')}`);
  };

  return (
    <Link
      href={link}
      className="flex h-[325px] w-[252px] shrink-0 flex-col overflow-hidden rounded-2xl border border-peppercorn-200 hover:no-underline hover:shadow-md focus:border-2 focus:border-peppercorn-800 focus:outline-none desktop:w-[282px]"
      onClick={trackCardClick}
      data-testid={title}
    >
      <picture className="h-[200px] w-[252px] overflow-hidden rounded-t-2xl desktop:w-[282px]">
        <source srcSet={imageAvif.src} type="image/avif" />
        <source srcSet={imageWebp.src} type="image/webp" />
        <source srcSet={imagePng.src} type="image/png" />
        <img
          alt={imageAlt}
          className="h-full w-full object-cover"
          decoding="async"
          height={200}
          loading="lazy"
          src={imagePng.src}
          width={282}
        />
      </picture>

      <div className="flex flex-1 flex-col justify-center p-4">
        <h4 className="text-xs font-bold uppercase text-peppercorn-800">{title}</h4>
        <div className="flex justify-between gap-3">
          <p className="text-lg font-bold text-peppercorn-800">{description}</p>
          <Icon className="mt-2 text-peppercorn-800" icon={faChevronRight} />
        </div>
      </div>
    </Link>
  );
};

export default CaseStudiesCard;
